const SAVE_STATUS = 'SAVE_STATUS';

export default {
  SAVE_STATUS,
};
